module.exports = __webpack_public_path__ + "static/case-hp-01-525e957383e03ec4cca42ac6f8fe106c.jpg";